// extracted by mini-css-extract-plugin
export var externalLink = "_b2-0";
export var internalLinkLabel = "_b2-1";